import { useEffect, useState } from "react";
import { tokenHealthClient } from "src/services/requestClient";

export default function useTokenHistogram(pinWidth) {
  const [data, setData] = useState(null);

  useEffect(async () => {
    const histogramData = await tokenHealthClient.get(`/v1/tokens/histogram?type=credit_score&range_width=${pinWidth}`);
    setData(histogramData);
  }, [pinWidth]);

  return data;
}
